import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { showSystemToast } from 'view/components/SystemToast';

export const useMadeFavoriteById = (): any => {
  const { data, isLoading, send } = useRequest({
    /* url: `/api/v1/jobPosts/${jobPostId}`, */
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
  });

  const sendFavoriteInfo = (jobPostId, successFunction, isFavourited) => {
    send({}, `/api/v1/favourites/${jobPostId}`).then((res) => {
      successFunction();
      if (isFavourited) {
        showSystemToast('success', 'Saved', 'Candidate removed from favorites list');
      } else {
        showSystemToast('success', 'Saved', 'Candidate saved to favorites list');
      }
    });
  };

  return {
    isLoading,
    sendFavoriteInfo,
    data,
  };
};
